module.exports = __webpack_public_path__ + "img/titles3.a7a3b8b5.png";